import { render, staticRenderFns } from "./Locale.vue?vue&type=template&id=c0daa1f2&"
import script from "./Locale.vue?vue&type=script&lang=js&"
export * from "./Locale.vue?vue&type=script&lang=js&"
import style0 from "./Locale.vue?vue&type=style&index=0&id=c0daa1f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports